import React from 'react';
import { __ } from 'artsteps2-common';
import publicConfig from 'artsteps2-config/public.json';

import Dialog from '../../../generic/Dialog';
import { getUIProperty } from '../../../../reducers';
import { setUIProperty } from '../../../../actions';
import {
  compose,
  withState,
  withDispatch,
  withLifecycle,
  withLocalState,
} from '../../../../enhancers';
import createYourOwnImage from '../../../../styles/images/templates/CreateYourOwn.png';
import industrialImage from '../../../../styles/images/templates/Industrial_new.jpg';
import modernSpaceImage from '../../../../styles/images/templates/ModernSpace.PNG';
import contempSpaceImage from '../../../../styles/images/templates/contempSpace.jpg';

export const API_URI = `${publicConfig.api.hostname}`;
const FILE_SYSTEM_ROOT_URL = `${publicConfig.usersFileSystemUrl}`;
const theFinalPath = process.env.NODE_ENV === 'development' ? API_URI : FILE_SYSTEM_ROOT_URL;

const TEMPLATES = [
  {
    title: 'Industrial Venue',
    path: `${theFinalPath}/templates/template_3.room`,
    image: industrialImage,
  },
  {
    title: 'Modern Venue',
    path: `${theFinalPath}/templates/template_4.room`,
    image: modernSpaceImage,
  },
  {
    title: 'Contemporary Venue',
    path: `${theFinalPath}/templates/template_7.room`,
    image: contempSpaceImage,
  },
];

export const ExhibitionTemplatePanelView = ({
  exhibitionNotEmpty,
  selectedTemplate = '',
  selectingTemplate = false,
  displayDialog = false,
  setSelectingTemplate = () => Promise.resolve(false),
  onTemplateSelect = () => Promise.resolve(false),
  onCloseDialog = () => Promise.resolve(false),
  openDialog = () => Promise.resolve(false),
  requestIsEmpty = () => Promise.resolve(false),
  onTogglePlacement = () => Promise.resolve(false),
  isExhibitionEmpty = true,
  requestingIsEmpty = false,
  templateClicked = false,
  onTemplateClicked = () => false,
  importedAt,
}) => (
  <div className="exhibition-space-editor">
    <div className="toolbar-section">
      <h4>{__('create_your_own')}</h4>
      <div className="template-list">
        <div
          role="button"
          tabIndex={0}
          className={`item ${!selectedTemplate || selectedTemplate === '' ? 'selected' : ''}`}
          onKeyPress={event => event.keyCode === 13 && setSelectingTemplate('')}
          onClick={() => {
            if (selectedTemplate === '') return;
            onTemplateClicked(!templateClicked);
            setSelectingTemplate('');
          }}
          data-tooltip="default"
          data-inverted
          data-position="top center"
        >
          <img alt="" className="ui image medium" src={createYourOwnImage} />
        </div>
        <h4>{__('exhibition_templates')}</h4>
        {TEMPLATES.map(t => (
          <div
            key={t.path}
            role="button"
            tabIndex={0}
            className={`item ${selectedTemplate === t.path ? 'selected' : ''} ${
              selectedTemplate === t.path ? 'inactive' : ''
            }`}
            onKeyPress={event => event.keyCode === 13 && setSelectingTemplate(t.path)}
            onClick={() => {
              if (t.path === selectedTemplate) return;
              setSelectingTemplate(t.path);
              onTemplateClicked(!templateClicked);
            }}
            data-tooltip={__(t.title)}
            data-inverted
            data-position="top center"
          >
            <img className="ui image medium" src={t.image} alt={__('place_wall')} />
          </div>
        ))}
        <div>
          <h5>{__('more_to_come_soon')}</h5>
        </div>
        <Dialog
          open={displayDialog}
          title={__('content_deletion')}
          message={__('confirm_content_deletion')}
          type="warning"
          onConfirm={() => {
            onTogglePlacement();
            onTemplateSelect(selectingTemplate);
            onCloseDialog();
            requestIsEmpty();
          }}
          onReject={() => {
            onCloseDialog();
          }}
        />
      </div>
    </div>
  </div>
);

const mapState = (state, { exhibitionId }) => ({
  selectingTemplate: getUIProperty(state, `exhibitions/${exhibitionId}/selectingTemplate`),
  selectedTemplate:
    getUIProperty(state, `exhibitions/${exhibitionId}/templatePath`) === '' ||
    getUIProperty(state, `exhibitions/${exhibitionId}/templatePath`)
      ? getUIProperty(state, `exhibitions/${exhibitionId}/templatePath`)
      : getUIProperty(state, `exhibitions/${exhibitionId}/import/templatePath`),
  displayDialog: getUIProperty(state, `exhibitions/${exhibitionId}/displayDialog`),
  exhibitionNotEmpty:
    !!(
      getUIProperty(state, `exhibitions/${exhibitionId}/export/artifacts`) ||
      getUIProperty(state, `exhibitions/${exhibitionId}/import/artifacts`) ||
      []
    ).length ||
    !!(
      getUIProperty(state, `exhibitions/${exhibitionId}/export/displayCases`) ||
      getUIProperty(state, `exhibitions/${exhibitionId}/import/displayCases`) ||
      []
    ).length ||
    !!(
      getUIProperty(state, `exhibitions/${exhibitionId}/export/walls`) ||
      getUIProperty(state, `exhibitions/${exhibitionId}/import/walls`) ||
      []
    ).length,
  isExhibitionEmpty: !!getUIProperty(state, `exhibitions/${exhibitionId}/isEmpty`),
  requestingIsEmpty: !!getUIProperty(state, `exhibitions/${exhibitionId}/requestingIsEmpty`),
  importedAt: getUIProperty(state, `exhibitions/${exhibitionId}/importedAt`),
});

const mapDispatch = (dispatch, { exhibitionId, requestingIsEmpty, placingWall, placingDoor }) => ({
  onTemplateSelect: templatePath =>
    dispatch(setUIProperty(`exhibitions/${exhibitionId}/templatePath`, templatePath)),
  setSelectingTemplate: templatePath => {
    dispatch(setUIProperty(`exhibitions/${exhibitionId}/selectingTemplate`, templatePath));
  },
  onCloseDialog: () => dispatch(setUIProperty(`exhibitions/${exhibitionId}/displayDialog`, false)),
  openDialog: () => dispatch(setUIProperty(`exhibitions/${exhibitionId}/displayDialog`, true)),
  requestIsEmpty: () => {
    dispatch(setUIProperty(`exhibitions/${exhibitionId}/requestingIsEmpty`, !requestingIsEmpty));
  },
  onTogglePlacement: () =>
    dispatch(setUIProperty(`exhibitions/${exhibitionId}/placingStructure`, undefined)),
});

const lifecycleMap = {
  onDidUpdate: (prevProps, props) => {
    if (prevProps.templateClicked !== props.templateClicked) {
      if (props.isExhibitionEmpty) {
        props.onTogglePlacement();
        props.onTemplateSelect(props.selectingTemplate);
        props.requestIsEmpty();
      } else {
        props.openDialog();
      }
    }
    if (prevProps.importedAt !== props.importedAt) {
      props.requestIsEmpty();
    }
  },
};

const ExhibitionTemplatePanel = compose(
  withLocalState('templateClicked', 'onTemplateClicked', false),
  withState(mapState),
  withDispatch(mapDispatch),
  withLifecycle(lifecycleMap),
)(ExhibitionTemplatePanelView);

export default ExhibitionTemplatePanel;
